import { ICurrency } from '@/common/interfaces/index.interface';
import ApiService from '@/services/ApiService';
import OldSessionStorageHelper from '@/helpers/OldSessionStorageHelper';
import CookieHelper from '@/helpers/CookieHelper';
import { IDeliveryType } from '@/common/interfaces/shared.interface';
import ErrorHandlerHelper from '@/helpers/ErrorHandlerHelper';

export default class CurrencyService {
  private currencies: ICurrency[];
  private apiService: ApiService;

  constructor(apiService: ApiService) {
    this.currencies = OldSessionStorageHelper.getCurrencyList();
    this.apiService = apiService;
  }

  public async init(): Promise<void> {
    await this.fetchCurrencies();
  }

  public async fetchCurrencies(): Promise<void> {
    if(this.currencies) {
      return;
    }

    this.currencies = await this.apiService.getCurrencies();
    OldSessionStorageHelper.setCurrencyList(this.currencies);
  }

  public getCurrencySymbol(currency: string): string {
    const tempCurrency = this.currencies.find(item => item.iso === currency.toUpperCase());

    if(tempCurrency) {
      return tempCurrency.symbol;
    }

    ErrorHandlerHelper.handleError(`Unknown currency: ${currency}`, { logToConsole: true });
    return ``;
  }

  public getPrice(price?: number, currency?: string): string {
    const internalCurrency = currency ?? CookieHelper.getCurrency();
    const internalPrice = price ?? 0;

    const currencySymbol = this.getCurrencySymbol(internalCurrency);

    return `${currencySymbol} ${internalPrice.toFixed(2).replace(`.`, `,`)}`;
  }

  public formatDeliveryTypeName(deliveryType: IDeliveryType, currency: string): string {
    const price = ` ${this.getPrice(deliveryType.cost, currency)}`;
    const { name } = deliveryType;
    const service = deliveryType.service ? `, ${deliveryType.service}` : ``;

    return `${name}${service}${price}`;
  }
}
